import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { isNil } from '@app/utils';
import { ARInvoiceSearchModel } from '../models';

@Injectable({ providedIn: 'root' })
export class ArInvoiceService {
	endpointBase = '/api/arinvoice';

	constructor(private readonly http: HttpClient) {}

	searchInvoices(filter: ARInvoiceSearchModel): Observable<any> {
		const params = {
			Ids: filter.Ids,
			StatusId: filter.StatusId,
			FromDate: filter.FromDate,
			ToDate: filter.ToDate,
			CustomerId: filter.CustomerId && filter.CustomerId > 0 ? filter.CustomerId : null,
			SiteId: filter.SiteId && filter.SiteId > 0 ? filter.SiteId : null,
			UserName: filter.UserName && filter.UserName !== 'All Users' ? filter.UserName : null,
		};

		if (isNil(params.UserName)) {
			delete params.UserName;
		}

		return this.http.get(`${this.endpointBase}/search`, {
			params: params,
		});
	}
}
